/* Number 6 Books theme: quantity steppers and the age filter. No dependencies. */
(function () {
  'use strict';

  // Quantity steppers: buttons with data-qty-step="-1" or "1" inside .n6-qty
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;
    var wrap = button.closest('.n6-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = (parseInt(input.value || '0', 10) || 0) + parseInt(button.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Age filter on the Books page: chips with data-age-filter="all|4-7|8-12|10-14"
  var chips = document.querySelectorAll('[data-age-filter]');
  if (chips.length) {
    var cards = document.querySelectorAll('[data-ages]');
    var status = document.querySelector('[data-age-status]');
    var apply = function (age) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = age === 'all' || card.getAttribute('data-ages').split(' ').indexOf(age) !== -1;
        card.hidden = !match;
        if (match) shown += 1;
      });
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-age-filter') === age ? 'true' : 'false');
      });
      if (status) status.textContent = shown === 1 ? '1 book' : shown + ' books';
    };
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { apply(chip.getAttribute('data-age-filter')); });
    });
    var start = (new URLSearchParams(window.location.search)).get('age');
    if (start && document.querySelector('[data-age-filter="' + start + '"]')) apply(start);
  }

  // Cart page: submit the form when a quantity changes
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (event) {
      if (event.target.matches('input[name="updates[]"]')) cartForm.submit();
    });
  }
})();
